<template>
  <section class="plans" id="plans">
      <div class="plans__content container">
        <h1 class="plans__title">Our Plans</h1>
        <p class="plans__description">
          Tap into our vast investor network with Sequire SMS. Engage with a diverse audience, and make a lasting impact on your brand.
        </p>
        <div class="plans__cards-container">
          <div class="plans__card">
            <div class="plans__card--header">
              <div class="--title">
                <h2>Bronze</h2>
              </div>
              <div class="--features">
                <div class="--features__text">
                  <i class="fa-solid fa-circle-check"></i>
                  <p>Reach up to <b>100K</b> Sequire's proprietary database of investors</p>
                </div>
                <p class="--features__price">$5K</p>
              </div>
            </div>
            <div class="plans__btn btn">
              <a href="https://buy.stripe.com/bIY16ygP4fkccw09B5" target="_blank">
                <button class="button">Buy Now</button>
              </a>
            </div>
          </div>
          <div class="plans__card">
            <div class="--title">
              <h2>Silver</h2>
            </div>
            <div class="--features">
              <div class="--features__text">
                <i class="fa-solid fa-circle-check"></i>
                <p>Reach up to <b>220K</b> Sequire's proprietary database of investors</p>
              </div>
              <p class="--features__price">$10K</p>
              <p class="--features__bonus">
                <i class="fa-solid fa-star"></i> *Bonus <b>20k</b> Investors!
              </p>
            </div>
            <div class="plans__btn btn">
              <a href="https://buy.stripe.com/3cs6qS8iy6NGfIceVq" target="_blank">
                <button class="button">Buy Now</button>
              </a>
            </div>
          </div>
          <div class="plans__card --dark">
            <div class="--title">
              <h2>Gold</h2>
            </div>
            <div class="--features">
              <div class="--features__text">
                <i class="fa-solid fa-circle-check"></i>
                <p>Reach up to <b>1MM</b> Sequire's proprietary database of investors</p>
              </div>
              <p class="--features__price">$40K</p>
              <p class="--features__bonus">
                <i class="fa-solid fa-star"></i> *Bonus <b>200k</b> Investors!
              </p>
            </div>
            <div class="plans__btn btn">
              <a href="https://buy.stripe.com/aEUbLc1Ua5JCanS4gN" target="_blank">
                <button class="button">Buy Now</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>

<style lang="scss" scoped>
@import "../styles/components/plans.scss";
</style>
